import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const DetailWrapper = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    marginTop: defaultTheme.spacing.l,
  }),
);

export const Detail = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.m,
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    padding: `${defaultTheme.spacing.s} 0`,
    p: {
      fontSize: defaultTheme.font.size.xs,
      lineHeight: defaultTheme.font.height.base,
      color: defaultTheme.color.grayScale.dark,
    },
  }),
);
